<template>
  <div class="app-container" style="padding-top: 5px">
    <!--       default-expand-all -->
    <el-tree
      ref="treeRef"
      :data="permissionList"
      :props="props"
      icon-class="el-icon-thumb"
      node-key="id"
      show-checkbox
    />
  </div>
</template>

<script>
import { getPermissionStructureByAlert, getPermissionStructureByField } from '@/api/role';

export default {
  name: 'PermissionTree',
  props: {
    permissionTreePop: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      props: {
        label: 'name',
        children: 'children'
      },
      // 权限树
      permissionList: [],
      // 选中了的节点
      selectedPermissionList: [],
      // 默认选中节点
      defSelectedPermissionList: [],
      reminderTip: false
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      // 1. 初始化所有数据，兜底空数组，避免undefined
      this.permissionList = [];
      this.defSelectedPermissionList = []; // 提前初始化，保证响应式
      let lastChildrenIdsConcat = [];

      try {
        // 第一个接口：获取字段权限结构
        const res = await getPermissionStructureByField();
        if (res.code === 200 && res.data?.permissionStructure) {
          this.permissionList.push(res.data.permissionStructure[0]);
          // 简化拼接：直接赋值，替代无意义的concat
          res.data.lastChildrenIds &&
            (lastChildrenIdsConcat = [...lastChildrenIdsConcat, ...res.data.lastChildrenIds]);
        }

        // 第二个接口：获取告警权限结构
        const resTip = await getPermissionStructureByAlert();
        if (resTip.code === 200 && resTip.data?.permissionStructure) {
          this.permissionList.push(resTip.data.permissionStructure[0]);
          resTip.data.lastChildrenIds &&
            (lastChildrenIdsConcat = [...lastChildrenIdsConcat, ...resTip.data.lastChildrenIds]);

          // 2. 筛选有效勾选id + 统一类型（核心修复）
          if (Array.isArray(this.permissionTreePop?.selectedPermissionList?.char)) {
            this.defSelectedPermissionList = this.permissionTreePop.selectedPermissionList.char
              .filter((item) => {
                // 双重校验：id存在 + 非空
                return item && lastChildrenIdsConcat.indexOf(item) !== -1;
              })
              .map((item) => {
                // ✅ 关键：统一id类型！和树节点的id类型保持一致（二选一）
                // ▶️ 如果树节点id是【数字】，打开下面注释，关闭字符串行
                // return Number(item);
                // ▶️ 如果树节点id是【字符串】，保留这行
                return String(item);
              });
          }
        }

        // 3. ✅ 核心关键：异步数据加载完成后，手动调用树组件勾选API（替代失效的default-checked-keys）
        this.$nextTick(() => {
          if (this.$refs.treeRef && this.defSelectedPermissionList.length) {
            // 清除原有勾选，避免残留
            this.$refs.treeRef.setCheckedKeys([]);
            // 设置新的勾选项，100%生效！
            this.$refs.treeRef.setCheckedKeys(this.defSelectedPermissionList);
            console.log('最终勾选的ID：', this.defSelectedPermissionList);
          }
        });
      } catch (err) {
        console.error('权限数据加载失败：', err);
      }
    },
    getSelectedPermissionList() {
      const checkedKeys = this.$refs.treeRef.getCheckedKeys();
      const halfCheckedKeys = this.$refs.treeRef.getHalfCheckedKeys();
      const checkedNodes = this.$refs.treeRef.getCheckedNodes();
      const halfCheckedNodes = this.$refs.treeRef.getHalfCheckedNodes();
      const menuPermissions = [];
      const buttonPermissions = [];
      checkedNodes.map((item) => {
        const code = item.code.split(':')[0];
        if (code === 'menu') {
          menuPermissions.push(item.code);
        } else {
          buttonPermissions.push(item.code);
        }
      });
      halfCheckedNodes.map((item) => {
        const code = item.code.split(':')[0];
        if (code === 'menu') {
          menuPermissions.push(item.code);
        } else {
          buttonPermissions.push(item.code);
        }
      });
      const permissionIds = halfCheckedKeys.concat(checkedKeys);

      return {
        permissionIds,
        menuPermissions,
        buttonPermissions
      };
    }
  }
};
</script>

<style scoped>
.el-tree {
  min-width: 100%;
  display: inline-block;
}

.tree {
  overflow: auto;
  max-height: 400px;
}
</style>
